export const APP_TIMEZONE = 'Asia/Singapore';
